import React, { useState } from 'react';
import './ForgotPassword.css';
import { Link } from 'react-router-dom';
import axios from 'axios';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage('Please enter your email address.');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/forgot-password`,
        { email }
      );
      setMessage('✅ Password reset link sent to your email.');
    } catch (error) {
      console.error('❌ Forgot Password Error:', error);
      if (error.response && error.response.data.message) {
        setMessage(`❌ ${error.response.data.message}`);
      } else {
        setMessage('❌ Failed to send reset link.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-box">
        <h2>Forgot Password</h2>
        <p>Enter your registered email to receive a password reset link.</p>

        <form className="forgot-form" onSubmit={handleReset}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        {message && <p className="message">{message}</p>}

        <div className="forgot-footer">
          <p>
            Remember your password? <Link to="/caretaker-login">Login Here</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
